import { Link } from "react-router-dom";
import { animeList } from "@/mocks/animeData";

export default function LatestSection() {
  const latest = animeList.filter((a) => a.isNew).slice(0, 6);

  return (
    <section className="relative bg-background-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-12">
            <Link
              to="/category/japanese-anime"
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/30 text-white/80 text-xs font-medium hover:border-white/60 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
            <h2 className="font-heading text-4xl md:text-6xl font-bold text-white text-right">
              最新更新
            </h2>
          </div>

          <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide">
            {latest.map((anime) => (
              <Link
                key={anime.id}
                to="/category/all"
                className="flex-shrink-0 w-52 md:w-60 group cursor-pointer"
              >
                <div className="relative bg-secondary-100 rounded-xl overflow-hidden mb-3.5 aspect-[3/4]">
                  <img
                    src={anime.coverImage}
                    alt={anime.title}
                    title={anime.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-2.5 left-2.5">
                    <span className="px-2 py-0.5 bg-primary-500 text-white text-[10px] font-semibold rounded-md whitespace-nowrap">
                      {anime.episode}
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                    <span className="text-white text-sm font-medium bg-white/20 backdrop-blur-sm px-4 py-1.5 rounded-full whitespace-nowrap">
                      <i className="ri-play-fill mr-1"></i>立即播放
                    </span>
                  </div>
                </div>
                <h3 className="text-white text-sm font-semibold leading-tight mb-1 truncate">
                  {anime.title}
                </h3>
                <p className="text-foreground-500 text-xs">
                  {anime.category} · 更新至 {anime.episode}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}